export default __webpack_public_path__ + "0636d7a3f2c4373734c66be611684ae6.png";